import React from 'react';

import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';

import styles from './PricingFeatures.scss';

const PricingFeatures = props => {
  // Since we define all our strings in the CMS, we can just list
  // the groups by ID and iterate.
  const groups = ['science', 'resources', 'anywhere'];

  const supportsGrid =
    typeof CSS !== 'undefined' && CSS.supports('display: grid');

  return (
    <div className="PricingFeatures" data-supports-grid={supportsGrid}>
      <h3 className="PricingFeatures__title">
        <ConnectedFormattedMessage id="pricing_page.features_title" />
      </h3>
      <div className="PricingFeatures__groups">
        {groups.map(id => {
          const img = require(`./feature-graphic-${id}.png`);
          return (
            <div className="PricingFeatures__group" key={id}>
              <img className="PricingFeatures__group-graphic" src={img} />
              <div className="PricingFeatures__group-title">
                <ConnectedFormattedMessage
                  id={`pricing_page.${id}_feature.title`}
                />
              </div>
              <div className="PricingFeatures__group-description">
                <ConnectedFormattedMessage
                  id={`pricing_page.${id}_feature.description`}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PricingFeatures;
